import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {
  useHistory,
  useIsDirectEntryCallback,
  useLocationState,
} from '@aboutyou/router';
import {useMemo} from 'react';

export const useLoadMoreButton = () => {
  const {isActive} = useIsFeatureActive('cp_load_more_button');
  const getIsDirectEntry = useIsDirectEntryCallback();
  const history = useHistory();

  const wasLoadMoreButtonPreviouslyClicked = useLocationState<{
    wasLoadMoreButtonClicked?: boolean;
  }>()?.wasLoadMoreButtonClicked;

  const onClick = () => {
    // If the user reloads after clicking load more, the button shouldn't reappear.
    history.replace({
      ...history.location,
      state: {wasLoadMoreButtonClicked: true},
    });
  };

  const shouldShowLoadMoreButton = useMemo(() => {
    if (!isActive) {
      return false;
    }

    if (wasLoadMoreButtonPreviouslyClicked) {
      return false;
    }

    if (!getIsDirectEntry()) {
      return false;
    }

    return true;
  }, [getIsDirectEntry, isActive, wasLoadMoreButtonPreviouslyClicked]);

  return {shouldShowLoadMoreButton, onClick};
};
